import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Swal from "sweetalert2";
import { requestDeleteUser } from "../../api/signcard";
import { useSetUserSession } from "../../state/user-session";
import Header from "../../components/header/header";
import { BackBtn } from "../../components/header/btn/back-btn";
import Footer from "../../components/footer";


export default function AccountDeletePage() {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();
  const [, logout] = useSetUserSession()

  const toggle = () => setAgree(!agree)

  const deleteAccount = async () => {
    try {
      await requestDeleteUser()

      await Swal.fire({
        title: '계정이 성공적으로 삭제되었습니다.',
        customClass: 'swal-alert',
        allowOutsideClick: false,
        confirmButtonText: '확인',
        confirmButtonColor: '#2D2D2D'
      })

      await logout()
      navigate("/")
    } catch (e) {
      await Swal.fire({
        title: '계정 삭제에 실패하였습니다.',
        text: '관리자에게 문의해주세요.',
        customClass: 'swal-alert',
        allowOutsideClick: false,
        confirmButtonText: '확인',
        confirmButtonColor: '#2D2D2D'
      })
    }
  }

  return (
    <div className="Layer">
      <Header>
        <BackBtn onClick={() => navigate(-1)} />
      </Header>
      <div className="Layer-inner">
        <div className="contents-container">
          <div className="title-container">
            <h3>계정 지우기</h3>
          </div>
          <div className="desc-container">
            <p >
              계정을 지우시면 SIGN 웹 내에 저장된 모든 연락처 목록 지워지며 모든 데이터는 복구가 불가능합니다.
            </p>
            <p className="gray-150">
              *단 기기 내에 저장된 연락처는 유지됩니다.
            </p>
            <div className="checkboxs-container">
              <label>
                <input id="agree-delete-checkbox" type="checkbox" className="checkbox" onClick={toggle} />
                <span className="checkdesc">안내사항을 모두 확인하였으며, 이에 동의합니다.</span>
              </label>
            </div>
          </div>
        </div>
        <div className="primary-btn-container">
          <button className={`btn ${agree ? "primary" : "prevent-select"}`} onClick={deleteAccount}>계정 지우기</button> {/* 컴포넌트로 빼기 */}
        </div>
      </div>
      <Footer />
    </div>
  )
}